<script setup lang="ts">
import { computed } from "vue";
import { storeToRefs } from "pinia";

import { useEditTransaction } from "@/components/EditTransaction/state.ts";
import { makeRule } from "@/functions/recurrence.ts";

import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";
import Recurrence from "@/components/Recurrence/index.vue";
import { Frequency, type RRule } from "rrule";

const state = useEditTransaction();

const { recurrence } = storeToRefs(state);

// Mirrors the store instead of caching it: on edit the stored rule arrives after mount, and the
// panel has to be built from that rule rather than from its own defaults.
const isRecurring = computed({
  get: () => recurrence.value !== null,
  set: (enabled: boolean) => {
    recurrence.value = enabled
      ? makeRule({ freq: Frequency.MONTHLY, interval: 1, count: null, until: null })
      : null;
  },
});

const onChange = (rule: RRule) => (recurrence.value = rule);
</script>

<template>
  <div class="mt-2 sm:col-span-2 sm:mt-0">
    <SwitchGroup as="div" class="flex items-center justify-between">
      <span class="flex grow flex-col">
        <SwitchLabel as="span" class="text-sm/6 font-medium text-gray-900" passive
          >Herhalen</SwitchLabel
        >
      </span>
      <Switch
        v-model="isRecurring"
        :class="[
          isRecurring ? 'bg-indigo-600' : 'bg-gray-200',
          'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2',
        ]"
      >
        <span
          :class="[
            isRecurring ? 'translate-x-5' : 'translate-x-0',
            'pointer-events-none inline-block size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
          ]"
          aria-hidden="true"
        />
      </Switch>
    </SwitchGroup>

    <Recurrence v-if="isRecurring" :initial-value="recurrence" @changed="onChange"></Recurrence>
  </div>
</template>
